const isWindowDefined = () => typeof window !== "undefined";
const isFalsy = (value) => !value;
const isFalsyFilter = (value) => !value || typeof value === "object" || typeof value === "function" || typeof value === "boolean";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isFalsy,
  isFalsyFilter,
  isWindowDefined
}, Symbol.toStringTag, { value: "Module" }));
export {
  isFalsy as a,
  isWindowDefined as b,
  isFalsyFilter as c,
  index as i
};
//# sourceMappingURL=index-CJNq9Per.js.map
